import React from 'react';
import { useImpersonation } from './ImpersonationContext';
import { AlertTriangle, XCircle } from 'lucide-react';
import { Button } from './ui/button';

export function ImpersonationBanner() {
  const { session, endImpersonation } = useImpersonation();

  if (!session) return null;

  return (
    <div className="bg-amber-500 text-white px-4 py-2 flex items-center justify-between shadow-md z-[100] relative">
      <div className="flex items-center gap-2">
        <AlertTriangle className="h-5 w-5" />
        <span className="font-bold">
          You are viewing as CLIENT USER: {session.targetUserName}
        </span>
        <span className="text-amber-100 text-sm ml-2 hidden sm:inline">
          (All actions are audited)
        </span>
      </div>
      <Button 
        variant="secondary" 
        size="sm" 
        onClick={endImpersonation}
        className="bg-white text-amber-600 hover:bg-amber-50 border-none font-semibold h-8"
      >
        <XCircle className="h-4 w-4 mr-2" />
        Exit Impersonation
      </Button>
    </div>
  );
}
